export default {"src":"/_next/static/media/GS-Icon-Live.ebd9b2dc.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};